export const environment = {
  production: true,

  BaaseUrl: "https://goldisapi.gonbadedanesh.com",
  ReportBaseUrl: "https://goldisreport.gonbadedanesh.com/",


  AdobeConnect: "https://ac1.gonbadedanesh.com",


  // BaaseUrl: "http://188.75.69.58:5040/",
  // ReportBaseUrl: "http://188.75.69.58:5041/",

  dateFormat: "YYYY/M/D HH:mm",
  fullDateFaFormat: "jYYYY/jM/jD HH:mm",
  dateFaFormat: "jYYYY/jMM/jDD",
  versionCheckURL: 'version.json',
  siteTitle: 'سامانه مدیریت آموزش :: گنبد دانش ::'
};
